import { render, staticRenderFns } from "./project.vue?vue&type=template&id=b89140ac&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=b89140ac&prod&lang=scss&scoped=true"
import style1 from "./project.vue?vue&type=style&index=1&id=b89140ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89140ac",
  null
  
)

export default component.exports